import React from 'react';
import type { Application } from '../types/application.types';
import { isApplicationApproved } from '../utils/application-status.utils';
import { BookingDetailsStep } from './steps/BookingDetailsStep';
import { ClientInfoStep } from './steps/ClientInfoStep';
import { DocumentsStep } from './steps/DocumentsStep';
import { FinancialStep } from './steps/FinancialStep';
import { OptionsServicesStep } from './steps/OptionsServicesStep';
import { PaymentConfirmationStep } from './steps/PaymentConfirmationStep';
import { ValidationStep } from './steps/ValidationStep';

interface StepContentProps {
  step: number;
  application: Application;
  allStepsVisited: boolean;
}

export const StepContent: React.FC<StepContentProps> = ({ step, application, allStepsVisited }) => {
  console.log('[StepContent] Rendering step:', step, 'All visited:', allStepsVisited, 'Status:', application.status);

  const renderStep = () => {
    switch (step) {
      case 0:
        return <ClientInfoStep application={application} />;
      case 1:
        return <BookingDetailsStep application={application} />;
      case 2:
        return <OptionsServicesStep application={application} />;
      case 3:
        return <FinancialStep application={application} />;
      case 4:
        return <DocumentsStep application={application} />;
      case 5:
        // Si le dossier est déjà validé (APPROVED ou CONFIRMED), afficher l'UI de confirmation de paiement
        if (isApplicationApproved(application.status)) {
          return <PaymentConfirmationStep application={application} />;
        }
        // Sinon, afficher l'étape de validation normale
        return <ValidationStep application={application} allStepsVisited={allStepsVisited} />;
      default:
        console.error('[StepContent] Invalid step number:', step);
        return null;
    }
  };

  return <div className="bg-white rounded-lg border border-slate-200 p-6 min-h-[400px]">{renderStep()}</div>;
};
